module.exports = {
    common: {
        requestProcessFail: 'การประมวลผลคำขอล้มเหลว',
        requestFail: 'คำขอล้มเหลว',
        networkError: 'คำขอเครือข่ายล้มเหลว กรุณาลองใหม่ภายหลัง',
        notFound: 'ไม่พบที่อยู่คำขอ',
        serverError: 'ข้อผิดพลาดภายในเซิร์ฟเวอร์',
        selectCountry: 'กรุณาเลือกประเทศ',
        confirmed: 'ยืนยันแล้ว',
        cancelled: 'ยกเลิกแล้ว...',
        back: 'กลับ',
    },

    homePage: {
        alreadyUse: 'ใช้แล้ว',
        remain: 'คงเหลือ',
        search: 'ค้นหา',
        findIccid: 'วิธีค้นหา ICCID',
        fillIccid: 'กรอกหมายเลข SIM Card ICCID',
        changeLanguage: 'เปลี่ยนภาษา',
        confirm: 'ยืนยัน',
        selectLanguage: 'กรุณาเลือกภาษา',
        selectImageFile: 'กรุณาเลือกไฟล์รูปภาพ',
        processing: 'กำลังดำเนินการ...',
        recognizeSuccess: 'จดจำสำเร็จ',
        recognizeFail: 'จดจำไม่สำเร็จ กรุณาลองอีกครั้ง',
        recognizeEmpty: 'ไม่พบ ICCID',
        compressFail: 'การบีบอัดล้มเหลว',
        takePhoto: 'ถ่ายภาพ',
        fromAlbum: 'เลือกจากอัลบั้ม',
        recognizing: 'กำลังจดจำ...',
        openingCamera: 'กำลังเปิดกล้อง...',
        cameraFail: 'เปิดกล้องไม่สำเร็จ',
        scanFail: 'จดจำไม่สำเร็จ กรุณาเล็งไปที่รหัส QR',
    },
    planPage: {
        contact: 'ติดต่อ',
        expireNotify: 'แพ็กเกจของคุณใกล้หมดอายุแล้ว ไม่สามารถดูข้อมูลแบบเรียลไทม์ได้ กรุณาต่ออายุแพ็กเกจทันที',
        dataUsed: 'ดาต้าที่ใช้แล้ว',
        dataRemain: 'ดาต้าที่คงเหลือ',
        planStatus: 'สถานะแพ็กเกจ',
        planAutoRenew: 'ต่ออายุอัตโนมัติ',
        planOrders: 'รายละเอียดคำสั่งซื้อ',
        planCountry: 'ประเทศ',
        planPackage: 'แพ็กเกจ',
        realPakcage: '9.9 บาท / 30 วัน',
        autoRenewNotify: 'ต่ออายุแพ็กเกจทุก 30 วัน 75.6 บาท ยกเลิกได้ทุกเวลา',
        goForPurchase: 'ไปที่การซื้อ',
        every: 'ทั้งหมด',
        days: 'ท้องฟ้า',
        lifetimeFreeFlow: 'เน็ตฟรีตลอดชีพ',
        renew: 'ต่ออายุแผน ยกเลิกได้ตลอดเวลา',
        detail: 'รายละเอียด',
        nodata: 'ไม่มีแพ็คเกจ',
        autoRenewSaying: 'ใบแจ้งยอดต่ออายุอัตโนมัติ',
        autoRenewSay1: 'คุณสามารถยกเลิกการต่ออายุอัตโนมัติได้ตลอดเวลา และจะไม่มีการเรียกเก็บเงินเพิ่มเติมหลังจากการยกเลิก.',
        autoRenewSay2: 'เพลิดเพลินไปกับราคาที่ต่ำสุดๆ.',
        renewNoticeTitle: 'ประกาศสำคัญ',
        renewNotice1: 'แพ็กเกจของคุณจะเปิดใช้งานทันทีหลังจากชำระเงินสำเร็จ',
        renewNotice2: 'นี่คือการสมัครสมาชิกแบบต่ออายุอัตโนมัติ โปรดตรวจสอบรายละเอียดก่อนซื้อ',
        agreePrefix: 'เมื่อดำเนินการต่อ แสดงว่าคุณยอมรับ',
        subscribePolicy: 'นโยบายการสมัครสมาชิก',
        agreeMiddle: ' และ ',
        refundPolicy: 'นโยบายการคืนเงิน',
        agreeSuffix: '',
        close: 'การปิด',
        subscription: 'ยกเลิกการสมัคร',
        cancelSubscription: 'ยืนยันการยกเลิกการสมัคร？',
        conform: 'ยืนยัน',
        cancel: 'ยกเลิก',
        Unlimited: 'ไม่จำกัด',
        cardLeftTip: 'เติม 360 วันใช้ได้สูงสุด 540 วัน',
        cardLeftTip270: 'เติม 180 วันใช้ได้สูงสุด 270 วัน',
        purchaseTitle: 'ซื้อแพ็กเกจ'
    },
    couponRedeem: {
        title: 'คูปองต่ออายุพิเศษ',
        titleNewbie: 'คูปองพิเศษสำหรับลูกค้าใหม่',
        subtitle: 'ขอบคุณที่อยู่กับเรา!',
        bullet1: 'จำกัดหนึ่งคูปองต่อหนึ่ง ICCID',
        bullet2: 'ใช้ได้จนถึง {date}',
        bullet3: 'ใช้ได้เพียงครั้งเดียว!',
        claimNow: 'รับทันที',
        goToUse: 'ไปใช้',
        receiveSuccess: 'รับคูปองสำเร็จ',
        receiveMissing: 'ข้อมูลคูปองหรือ ICCID ไม่ถูกต้อง',
        useToast: 'โปรดใช้คูปองนี้เมื่อชำระค่าแพ็กเกจ',
        claimToast: 'โปรดติดต่อฝ่ายสนับสนุนเพื่อแลกรับสิทธิ์',
        empty: 'ยังไม่มีคูปอง',
        noCouponMsg: 'ไม่มีคูปอง',
        buyDirect: 'ซื้อทันที',
        loading: 'กำลังโหลด...',
    },
    payPage: {
        orderRecords: 'บันทึกคำสั่ง',
        payContact: 'เบอร์ติดต่อ',
        payPackage: 'แพ็กเกจ',
        payDuration: 'ระยะเวลา',
        payTotal: 'ยอดชำระ',
        paySelectPayment: 'เลือกวิธีการชำระเงิน',
        payCard: 'บัตร',
        cardDesc: 'สนับสนุนการสมัครสมาชิกเท่านั้น',
        payCardBankCredit: 'บัตรธนาคาร / เครดิต',
        cardSupportHint: 'รองรับ Visa, Mastercard, Apple Pay, Google Pay',
        currentSelected: 'เลือกอยู่',
        autoBadge: 'อัตโนมัติ',
        subscribeCardDeduct: 'สมัครสมาชิกด้วยบัตรเครดิต/เดบิต',
        subscribeEwalletDeduct: 'สมัครสมาชิกด้วยกระเป๋าเงินอิเล็กทรอนิกส์',
        payOnceTitle: 'ชำระเงินครั้งเดียว',
        payOnceDesc: 'ชำระครั้งเดียว ไม่ต่ออายุอัตโนมัติ หนึ่งวิธีชำระต่อแถว',
        rechargeEwalletDesc: 'ชำระครั้งเดียวด้วยกระเป๋าเงินอิเล็กทรอนิกส์',
        rechargeQrisDesc: 'ชำระด้วยการสแกน',
        rechargeBankDesc: 'ชำระครั้งเดียวด้วยการโอนธนาคาร',
        rechargeRetailDesc: 'ชำระที่ร้านสะดวกซื้อ',
        payEWallet: 'การชำระเงิน',
        payComfirm: 'ยืนยันการชำระเงิน',
        paymentSecureHint: 'ข้อมูลการชำระเงินของคุณปลอดภัยและเข้ารหัสแล้ว',
        inputContact: 'กรุณากรอกข้อมูลติดต่อ',
        contactAppNumber: 'หมายเลข {app}',
        contactUpdateViaApp: 'อัปเดตคำสั่งซื้อจะถูกส่งผ่าน {app}',
        contactPhonePlaceholder: 'กรุณากรอกหมายเลข',
        contactPhoneMinLength: 'กรุณากรอกอย่างน้อย 8 หลัก',
        orderCouponLoading: 'กำลังโหลดคูปอง...',
        couponAppliedSub: 'ใช้กับคำสั่งซื้อนี้แล้ว',
        couponAvailableSub: 'ใช้ได้กับคำสั่งซื้อนี้',
        couponDeductLabel: 'ส่วนลดคูปอง',
        amountAfterDeduction: 'ยอดหลังหักส่วนลด',
        subscribeDetailTitle: 'รายละเอียดการสมัครสมาชิก (ต่ออายุอัตโนมัติ)',
        subscribeDetailSubtitle: 'ดูรอบการเรียกเก็บเงิน กฎการต่ออายุ การยกเลิก และอื่น ๆ',
        subscribeDetailIntro: 'นี่คือการสมัครสมาชิกแบบต่ออายุอัตโนมัติ การดำเนินการต่อถือว่าคุณยอมรับเงื่อนไขด้านล่าง',
        subscribeBillingCycle: 'รอบการเรียกเก็บเงิน',
        subscribeBillingCycleVal: 'ทุก {days} วัน',
        subscribeAmount: 'จำนวนเงิน',
        subscribeAmountVal: '{amount} ต่อ {days} วัน',
        subscribeNextRenewal: 'การต่ออายุครั้งถัดไป',
        subscribeNextRenewalVal: 'เมื่อหมดอายุ ระบบจะเรียกเก็บเงินโดยอัตโนมัติ',
        subscribePaymentMethod: 'วิธีการชำระเงิน',
        subscribePaymentMethodVal: 'การต่ออายุในอนาคตจะถูกเรียกเก็บผ่านวิธีการชำระเงินนี้',
        subscribeCancelAnytime: 'ยกเลิกได้ทุกเมื่อ',
        subscribeCancelAnytimeVal: 'คุณสามารถยกเลิกการต่ออายุอัตโนมัติได้ก่อนวันเรียกเก็บเงินครั้งถัดไป หลังยกเลิก แพ็กเกจจะยังใช้งานได้จนกว่าจะหมดอายุ',
        subscribeActivation: 'การเปิดใช้งาน',
        subscribeActivationVal: 'แพ็กเกจของคุณจะเปิดใช้งานทันทีหลังชำระเงินสำเร็จ',
        refundSummaryTitle: 'นโยบายการคืนเงิน (สรุป)',
        refundSummarySubtitle: 'ดูสิทธิ์การคืนเงิน ขั้นตอน และข้อยกเว้น',
        refundSummaryIntro: 'การคืนเงินมีได้เฉพาะในกรณีต่อไปนี้:',
        refundSummaryCase1: 'ชำระเงินซ้ำ',
        refundSummaryCase2: 'ชำระเงินสำเร็จแต่แพ็กเกจยังไม่เปิดใช้งาน',
        refundSummaryCase3: 'ปัญหาทางเทคนิคที่เกิดจาก Franwell',
        refundSummaryDisclaimer: 'จะไม่มีการคืนเงินเมื่อแพ็กเกจเปิดใช้งานสำเร็จหรือใช้งานไปแล้วบางส่วน',
        refundSummaryLink: 'ดูนโยบายการคืนเงินฉบับเต็ม',
        agreeAutoRenew: 'ฉันเข้าใจว่านี่คือการสมัครสมาชิกแบบต่ออายุอัตโนมัติ และยอมรับข้อกำหนดด้านบน',
        agreePoliciesPrefix: 'ฉันได้อ่านและยอมรับ ',
        agreeAutoRenewRequired: 'โปรดยืนยันข้อกำหนดการสมัครสมาชิกแบบต่ออายุอัตโนมัติ',
        agreePoliciesRequired: 'โปรดยอมรับนโยบายการสมัครสมาชิกและนโยบายการคืนเงิน',
        agreeConsentRequired: 'โปรดเลือกช่องยอมรับข้อตกลงด้านบน',
        subscribePolicyPopupTitle: 'นโยบายการสมัครสมาชิก',
        subscribePolicySection1Title: '1. การสมัครสมาชิก',
        subscribePolicyS1Item1: 'การสมัครสมาชิกของคุณจะเริ่มทันทีหลังชำระเงินสำเร็จ',
        subscribePolicyS1Item2: 'การสมัครสมาชิกแต่ละครั้งมีอายุ {days} วัน',
        subscribePolicyS1Item3: 'การสมัครสมาชิกของคุณจะต่ออายุอัตโนมัติทุก {days} วัน',
        subscribePolicyS1Item4: 'จำนวนเงินต่ออายุคือ {amount} ต่อ {days} วัน',
        subscribePolicyS1Item5: 'การชำระเงินต่ออายุจะถูกหักอัตโนมัติจากวิธีการชำระเงินที่คุณเลือก',
        subscribePolicyS1Item6: 'คุณสามารถยกเลิกการต่ออายุอัตโนมัติได้ตลอดเวลาก่อนวันที่เรียกเก็บเงินครั้งถัดไป',
        subscribePolicyS1Item7: 'หลังยกเลิก การสมัครสมาชิกปัจจุบันของคุณจะยังคงใช้งานได้จนกว่าจะหมดอายุ',
        subscribePolicySection2Title: 'คู่มือการยกเลิกการสมัครสมาชิก',
        subscribePolicyS2Step1Label: 'ขั้นตอนที่ 1',
        subscribePolicyS2Step1: 'ไปที่หน้า 4G',
        subscribePolicyS2Step2Label: 'ขั้นตอนที่ 2',
        subscribePolicyS2Step2: 'ค้นหาปุ่มสมัครสมาชิก',
        subscribePolicyS2Step3Label: 'ขั้นตอนที่ 3',
        subscribePolicyS2Step3: 'แตะ "ปิดการต่ออายุอัตโนมัติ"',
        subscribePolicyS2Step4Label: 'ขั้นตอนที่ 4',
        subscribePolicyS2Step4: 'ยืนยันการยกเลิก',
        subscribePolicyS2Tip: 'คุณยังสามารถใช้บริการนี้ได้ตามปกติจนกว่าจะสิ้นสุดรอบการสมัครสมาชิกปัจจุบัน',
        subscribePolicyFullLink: 'ดูนโยบายการสมัครสมาชิกฉบับเต็ม',
        xenditSubscribeNoticeTitle: 'ประกาศสำคัญ',
        xenditSubscribeNotice1: 'คุณกำลังสมัครสมาชิกระหว่างวันที่ 29 ถึง 31',
        xenditSubscribeNotice2Prefix: 'การสมัครสมาชิกของคุณจะสำเร็จ แต่การเรียกเก็บเงินจริงจะเลื่อนไปเป็นวันที่ ',
        xenditSubscribeNotice2Highlight: '1 ของเดือนถัดไป',
        xenditSubscribeNotice3: 'เราจะมอบวันใช้งานฟรีในช่วงเวลานี้ให้คุณ เมื่อมีการหักเงินแล้ว วันแพ็กเกจของคุณจะถูกขยายอัตโนมัติ',
        xenditSubscribeNoticeConfirm: 'เข้าใจแล้ว',
        refundPolicyPopupTitle: 'นโยบายการคืนเงิน',
        refundPolicySection1Title: '1. มีสิทธิ์ได้รับเงินคืน',
        refundPolicyS1Intro: 'จะคืนเงินในกรณีต่อไปนี้:',
        refundPolicyS1Item1: 'ชำระเงินซ้ำ',
        refundPolicyS1Item2: 'ชำระเงินสำเร็จแต่แพ็กเกจยังไม่เปิดใช้งาน',
        refundPolicyS1Item3: 'ปัญหาทางเทคนิคที่เกิดจาก Franwell',
        refundPolicySection2Title: '2. ไม่มีสิทธิ์ได้รับเงินคืน',
        refundPolicyS2Intro: 'จะไม่คืนเงินในกรณีต่อไปนี้:',
        refundPolicyS2Item1: 'เปิดใช้งาน SIM และใช้บริการข้อมูลแล้ว',
        refundPolicyS2Item2: 'ใช้แพ็กเกจบางส่วนหรือทั้งหมด',
        refundPolicyS2Item3: 'เปลี่ยนใจหลังซื้อ',
        refundPolicyS2Item4: 'ปัญหาพื้นที่ให้บริการเครือข่ายหรือสัญญาณหลังเปิดใช้งานสำเร็จ',
        refundPolicySection3Title: '3. ขั้นตอนการคืนเงิน',
        refundPolicyS3Item1: 'จะดำเนินการคืนเงินภายใน 3-5 วันทำการ',
        refundPolicyS3Item2: 'เงินคืนจะส่งกลับไปยังวิธีการชำระเงินเดิม',
        selectPaymentRequired: 'กรุณาเลือกวิธีการชำระเงิน',
        paymentLinkInvalid: 'ลิงก์ชำระเงินไม่ถูกต้อง',
        redirectPaymentFailed: 'ไม่สามารถเปิดหน้าชำระเงินได้ กรุณาลองอีกครั้งด้วยตนเอง',
        createOrderFailed: 'สร้างคำสั่งซื้อไม่สำเร็จ',
        creatingOrder: 'กำลังสร้างคำสั่งซื้อเพื่อชำระเงิน...',
        paymentComponentLoadFailedRefresh: 'โหลดส่วนประกอบการชำระเงินไม่สำเร็จ กรุณารีเฟรชหน้า',
        paymentComponentLoadFailed: 'โหลดส่วนประกอบการชำระเงินไม่สำเร็จ',
        paymentFailed: 'การชำระเงินล้มเหลว',
        paymentCancelled: 'ยกเลิกการชำระเงินแล้ว',
        paymentInitFailed: 'เริ่มต้นการชำระเงินไม่สำเร็จ',
        indonesiaPhoneInvalid: 'รูปแบบไม่ถูกต้อง กรุณากรอกเบอร์โทรศัพท์อินโดนีเซียที่ถูกต้อง',
    },
    paySuccessPage: {
        pendingResult: 'ผลการสั่งซื้อที่รอดำเนินการ',
        activationSuccess: 'ส่งข้อมูลการเปิดใช้งานซิมการ์ดของคุณเรียบร้อยแล้ว',
        activationQuery: 'ตรวจสอบสถานะการเปิดใช้งาน',
        pendingPaymentTitle: 'รอการชำระเงิน',
        orderNoLabel: 'หมายเลขคำสั่งซื้อ',
        redirectingPayment: 'กำลังไปยังหน้าชำระเงิน...',
        pay: 'ชำระเงิน',
        orderNoMissing: 'ไม่พบหมายเลขคำสั่งซื้อ',
        paymentLinkInvalid: 'ลิงก์ชำระเงินไม่ถูกต้อง',
    },
    orderPage: {
        activated: 'เปิดใช้งานแล้ว',
        notActivated: 'ยังไม่เปิดใช้งาน',
        closed: 'ปิดแล้ว',
        activateFailed: 'เปิดใช้งานไม่สำเร็จ',
        paySuccess: 'สำเร็จ',
        payFailed: 'ล้มเหลว',
        notPaid: 'ยังไม่ได้ชำระ',
        refunded: 'คืนเงินแล้ว',
        Pending: 'แผนรอดำเนินการ',
        orderRecord: 'ประวัติการสั่งซื้อ',
        orderStatus: 'สถานะคำสั่งซื้อ',
        orderPayStatus: 'สถานะการชำระเงิน',
        orderCountry: 'ประเทศ',
        orderPackage: 'แพ็กเกจ',
        orderIccid: 'ICCID',
        orderOrderTime: 'เวลาสั่งซื้อ',
        back: 'กลับ'
    },
    deviceInfo: {
        title: 'ข้อมูลอุปกรณ์',
        userId: 'รหัสผู้ใช้',
        deviceId: 'รหัสอุปกรณ์',
        operatorAlertTitle: 'แจ้งเตือนการปลดล็อก',
        operatorAlert:
            'อุปกรณ์นี้ได้รับเงินอุดหนุนอย่างเป็นทางการ ทำให้มีราคาที่คุ้มค่ามากขึ้น และมาพร้อมกับซิมการ์ด 4G อย่างเป็นทางการเพื่อประสบการณ์การใช้งานที่ดีที่สุด หากคุณต้องการยกเลิกข้อจำกัด คุณสามารถเลือกปลดล็อกได้โดยมีค่าธรรมเนียม หลังจากปลดล็อกแล้ว คุณสามารถใช้ซิมการ์ดจากผู้ให้บริการรายอื่นที่รองรับได้',
        unlockPermanent: 'ปลดล็อกถาวร',
        unlockDescription: 'ชำระเงินครั้งเดียว ปลดล็อกอุปกรณ์ถาวร',
        unlockDescription01: 'หลังจากปลดล็อกแล้ว คุณสามารถใช้ซิมการ์ดจากผู้ให้บริการใดก็ได้',
        unlockImmediate: 'ปลดล็อกทันที',
        noticeTitle: 'คำแนะนำการปลดล็อก',
        unlockNotice:
            'คำเตือน: หากคุณได้ชำระเงินเรียบร้อยแล้ว การปลดล็อกจะมีผลภายใน 5–10 นาที โปรดเชื่อมต่อเครือข่ายและลองใหม่อีกครั้งภายหลัง'
    },

    deviceUnlockPaymentInfo: {
        title: 'ข้อมูลอุปกรณ์',
        userId: 'รหัสผู้ใช้',
        deviceId: 'รหัสอุปกรณ์',
        total: 'ยอดรวม',
        paySelectPayment: 'เลือกวิธีการชำระเงิน',
        payCard: 'บัตร',
        payEWallet: 'กระเป๋าเงินอิเล็กทรอนิกส์',
        payConfirm: 'ยืนยันการชำระเงิน',
        operatorAlert:
            'อุปกรณ์นี้ได้รับเงินอุดหนุนอย่างเป็นทางการ ทำให้มีราคาที่คุ้มค่ามากขึ้น และมาพร้อมกับซิมการ์ด 4G อย่างเป็นทางการเพื่อประสบการณ์การใช้งานที่ดีที่สุด หากคุณต้องการยกเลิกข้อจำกัด คุณสามารถเลือกปลดล็อกได้โดยมีค่าธรรมเนียม หลังจากปลดล็อกแล้ว คุณสามารถใช้ซิมการ์ดจากผู้ให้บริการรายอื่นที่รองรับได้',
        unlockPermanent: 'ปลดล็อกถาวร',
        unlockDescription: 'ชำระเงินครั้งเดียว ปลดล็อกอุปกรณ์ถาวร',
        unlockDescription01: 'หลังจากปลดล็อกแล้ว คุณสามารถใช้ซิมการ์ดจากผู้ให้บริการใดก็ได้',
        unlockImmediate: 'ปลดล็อกทันที',
        noticeTitle: 'คำแนะนำการปลดล็อก',
        unlockNotice:
            'คำเตือน: หากคุณได้ชำระเงินเรียบร้อยแล้ว การปลดล็อกจะมีผลภายใน 5–10 นาที โปรดเชื่อมต่อเครือข่ายและลองใหม่อีกครั้งภายหลัง',
        unlockConfirm: 'ยืนยัน',
        unlockRequestFail: 'คำขอล้มเหลว',
        unlockTipsTitle: 'คำแนะนำ',
        unlockedMsg: 'สินค้านี้ถูกปลดล็อกแล้ว ไม่จำเป็นต้องดำเนินการซ้ำ!',
        UnlockSuccessful: 'ยินดีด้วย! ปลดล็อกสำเร็จ!'
    },
    feedbackPage: {
        title: 'ข้อเสนอแนะ',
        heroTitle: 'บอกเราว่าเกิดอะไรขึ้น',
        heroSubtitle: 'เราจะช่วยคุณโดยเร็วที่สุด',
        ticketHistory: 'ประวัติตั๋วของฉัน',
        problemCategory: 'หมวดหมู่ปัญหา',
        issueSelectTitle: 'โปรดเลือกปัญหาเฉพาะ',
        issueSelectSubtitle: 'เลือกรายการที่ตรงกับสถานการณ์ของคุณมากที่สุด',
        next: 'ถัดไป',
        form: {
            describeTitle: 'อธิบายปัญหาของคุณ',
            describeSubtitle: 'โปรดให้รายละเอียดเพิ่มเติมเกี่ยวกับปัญหาที่คุณพบ',
            describePlaceholder: 'โปรดอธิบายปัญหาของคุณที่นี่... (สูงสุด 500 ตัวอักษร)',
            uploadPhotoTitle: 'อัปโหลดรูปภาพ (ไม่บังคับ)',
            uploadPhotoSubtitle: 'อัปโหลดได้สูงสุด 3 รูป',
            uploadScreenshotTitle: 'อัปโหลดภาพหน้าจอ (ไม่บังคับ)',
            uploadScreenshotSubtitle: 'ช่วยให้เราเข้าใจปัญหาได้ดีขึ้น',
            contactEmailTitle: 'อีเมลติดต่อ',
            contactEmailPlaceholder: 'example@email.com',
            orderNoTitle: 'หมายเลขคำสั่งซื้อ',
            orderNoPlaceholder: 'กรุณากรอกหมายเลขคำสั่งซื้อ',
            orderNoRequired: 'กรุณากรอกหมายเลขคำสั่งซื้อ',
            takePhoto: 'ถ่ายภาพ',
            chooseFromAlbum: 'เลือกจากอัลบั้ม',
            cancel: 'ยกเลิก',
            emailRequired: 'โปรดกรอกอีเมลติดต่อ',
            emailInvalid: 'โปรดกรอกอีเมลที่ถูกต้อง',
            describeRequired: 'โปรดอธิบายปัญหาของคุณ',
            uploading: 'กำลังอัปโหลด...',
            uploadFailed: 'อัปโหลดรูปไม่สำเร็จ กรุณาลองใหม่',
            submitting: 'กำลังส่ง...',
            submitFailed: 'ส่งไม่สำเร็จ กรุณาลองใหม่',
            confirmSelected: 'คุณเลือก:',
            pleaseMakeSure: 'โปรดตรวจสอบให้แน่ใจว่า:',
            checkSimInserted: 'ใส่ซิมการ์ดถูกต้อง',
            checkDataPlanActive: 'แพ็กเกจข้อมูลของคุณใช้งานได้',
            checkCameraPowered: 'กล้องเปิดอยู่',
            checkSignalStrength: 'ความแรงสัญญาณอย่างน้อย 2 ขีด',
            checkRestartCamera: 'ลองรีสตาร์ทกล้อง',
            confirmPrompt: 'โปรดยืนยันปัญหาข้างต้น',
            submit: 'ส่ง',
        },
        success: {
            title: 'ส่งสำเร็จ!',
            subtitle: 'ทีมสนับสนุนของเราได้รับคำขอของคุณแล้ว',
            ticketNumber: 'หมายเลขตั๋ว',
            submitTime: 'เวลาส่ง',
            responseTime: 'เราจะติดต่อกลับภายใน 24 ชั่วโมง (วันทำการ)',
            statusCheck: 'คุณสามารถตรวจสอบสถานะได้ใน "ตั๋วของฉัน"',
            myTickets: 'ตั๋วของฉัน',
            backToHome: 'กลับหน้าหลัก',
            copySuccess: 'คัดลอกสำเร็จ',
        },
        categories: {
            camera: { title: 'กล้อง', desc: 'กล้องออฟไลน์ ดูไม่ได้ ปัญหาโหมดกลางคืน' },
            sim: { title: 'SIM / เครือข่าย', desc: 'ไม่มีเครือข่าย สัญญาณอ่อน ปัญหา SIM' },
            recharge: { title: 'เติมเงิน / แพ็กเกจ', desc: 'เติมเงินล้มเหลว แพ็กเกจไม่อัปเดต คืนเงิน' },
            data: { title: 'การใช้ข้อมูล', desc: 'ใช้ข้อมูลสูง ข้อมูลคงเหลือไม่ถูกต้อง' },
            device: { title: 'ฟังก์ชันอุปกรณ์', desc: 'ตรวจจับการเคลื่อนไหว คลาวด์ การบันทึก' },
            order: { title: 'คำสั่งซื้อและการชำระเงิน', desc: 'ชำระเงินล้มเหลว คืนเงิน ใบแจ้งหนี้' },
            other: { title: 'อื่นๆ', desc: 'ปัญหาอื่นๆ' },
        },
        issues: {
            camera_offline: 'กล้องออฟไลน์',
            cannot_view_live: 'ดูสดไม่ได้',
            playback_failed: 'เล่นย้อนหลังล้มเหลว',
            night_vision: 'ปัญหาโหมดกลางคืน',
            motion_detection: 'ตรวจจับการเคลื่อนไหว',
            camera_restart: 'รีสตาร์ทกล้อง',
            camera_not_added: 'ยังไม่ได้เพิ่มกล้อง',
            sim_not_activated: 'SIM ยังไม่เปิดใช้งาน',
            no_network: 'ไม่มีเครือข่าย',
            weak_signal: 'สัญญาณอ่อน',
            roaming_issue: 'ปัญหาโรมมิ่ง',
            sim_replacement: 'เปลี่ยน SIM',
            cannot_detect_sim: 'ตรวจไม่พบ SIM',
            '4g_not_working': '4G ใช้งานไม่ได้',
            recharge_failed: 'เติมเงินล้มเหลว',
            recharge_not_effective: 'เติมเงินสำเร็จแต่ไม่มีผล',
            plan_not_updated: 'แพ็กเกจไม่อัปเดต',
            wrong_package: 'แพ็กเกจผิด',
            auto_renewal: 'ต่ออายุอัตโนมัติ',
            subscription: 'การสมัครสมาชิก',
            refund: 'คืนเงิน',
            coupon: 'คูปอง',
            high_data_usage: 'ใช้ข้อมูลสูง',
            data_used_too_fast: 'ใช้ข้อมูลเร็วเกินไป',
            remaining_data_incorrect: 'ข้อมูลคงเหลือไม่ถูกต้อง',
            usage_not_updated: 'การใช้งานไม่อัปเดต',
            need_usage_report: 'ต้องการรายงานการใช้งาน',
            payment_failed: 'ชำระเงินล้มเหลว',
            duplicate_payment: 'ชำระเงินซ้ำ',
            order_not_found: 'ไม่พบคำสั่งซื้อ',
            invoice: 'ใบแจ้งหนี้',
            discount: 'ส่วนลด',
            cloud_storage: 'คลาวด์สตอเรจ',
            recording: 'การบันทึก',
            sd_card: 'การ์ด SD',
            notification: 'การแจ้งเตือน',
            firmware_upgrade: 'อัปเกรดเฟิร์มแวร์',
            device_binding: 'ผูกอุปกรณ์',
            qr_code: 'คิวอาร์โค้ด',
            reset_device: 'รีเซ็ตอุปกรณ์',
            other: 'อื่นๆ',
        },
        history: {
            tabs: {
                all: 'ทั้งหมด',
                processing: 'กำลังดำเนินการ',
                waiting: 'รอดำเนินการ',
                resolved: 'แก้ไขแล้ว',
                closed: 'ปิดแล้ว',
            },
            status: {
                processing: 'กำลังดำเนินการ',
                waiting: 'รอดำเนินการ',
                resolved: 'แก้ไขแล้ว',
                closed: 'ปิดแล้ว',
            },
            deviceId: 'รหัสอุปกรณ์',
            iccid: 'ICCID',
            submitTime: 'เวลาส่ง',
            empty: 'ไม่พบตั๋ว',
            loading: 'กำลังโหลด...',
        },
    },

    PositiveReviewCashbackPopup: {
        title: 'Get free data',
        tip: 'with a 5-star review',
        confirm: 'Claim Now'
    },

    newbieCouponPopup: {
        titleOffer: 'ข้อเสนอพิเศษ',
        noThreshold: 'คูปองไม่มีเงื่อนไข',
        fullReduction: 'คูปองลดเมื่อครบยอด',
        nonSubscribeOnly: 'เฉพาะแพ็กเกจแบบไม่สมัครสมาชิก',
    }
}
